import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { convertSecondsToTime } from 'utils/timeHelper';
import format from 'date-fns/format';
import common from 'constants/common';

const ActivityRow = ({ activity }) => {
  const doctorName = () => {
    let name = '';
    if (activity.doctorLogin.firstName) {
      name += activity.doctorLogin.firstName;
    }
    if (activity.doctorLogin.lastName) {
      name += ` ${activity.doctorLogin.lastName}`;
    }
    return name;
  };

  const styleRange = (time) => {
    if (time / 60 < 10) return 'rangeRed';
    if (time / 60 < 20) return 'rangeOrange';
    if (time / 60 < 40) return 'rangeYellow';
    if (time / 60 < 60) return 'rangeGreen';
    return 'rangeLightGreen';
  };

  const getRange = (time) => {
    if (time / 60 < 10) return '< 10 min';
    if (time / 60 < 20) return '< 20 min';
    if (time / 60 < 40) return '< 40 min';
    if (time / 60 < 60) return '< 60 min';
    return '> 60 min';
  };

  return (
    <tr className="activity-row">
      <td data-label="Patient Name">
        <Link to={`/patient/${activity.actionTime.patientGuid}`}>
          <strong>
            {activity.login.firstName} {activity.login.lastName}
          </strong>
        </Link>
      </td>
      <td data-label="MRN">{activity.patient.mrn}</td>
      <td data-label="Contact">{activity.login.phone}</td>
      <td data-label="Insurance Plan Provider">
        {activity.patientInsurance.provider}
      </td>
      <td data-label="Insurance Plan Number">
        {activity.patientInsurance.number}
      </td>
      <td data-label="Physician">{doctorName()}</td>
      <td data-label="Number Of Reviews">{activity.readingReview.count}</td>
      <td data-label="Total Review Time">
        {convertSecondsToTime(activity.readingReview.time)}
      </td>
      <td data-label="Numbers Of Comments">{activity.totalComment.count}</td>
      <td data-label="Total Comment Time">
        {convertSecondsToTime(activity.totalComment.time)}
      </td>
      <td data-label="Numbers Of Manuals">
        {activity.patientManualInteraction.count}
      </td>
      <td data-label="Total Manual Time">
        {convertSecondsToTime(activity.patientManualInteraction.time)}
      </td>
      <td data-label="Numbers Of Calls">{activity.totalCall.count}</td>
      <td data-label="Total Call Time">
        {convertSecondsToTime(activity.totalCall.time)}
      </td>
      <td data-label="Last Call Time">
        {activity?.totalCall?.latest
          ? format(
              new Date(activity.totalCall.latest),
              common.dateFormats.dateAndTime,
            )
          : ''}
      </td>
      <td
        data-label="Range"
        className={`${styleRange(activity.totalTime)} range`}
      >
        {getRange(activity.totalTime)}
      </td>
      <td data-label="Total Time">
        {convertSecondsToTime(activity.totalTime)}
      </td>
    </tr>
  );
};

ActivityRow.propTypes = {
  activity: PropTypes.shape().isRequired,
};

export default ActivityRow;
